/**
 * Check objects for deep equality
 * source - https://levelup.gitconnected.com/how-to-get-a-perfect-deep-equal-in-javascript-b849fe30e54f
 *
 * @param objA
 * @param objB
 * @param ignoredKeys
 * @param map
 */
export function deepEqual(
  objA: any,
  objB: any,
  ignoredKeys: (Symbol | string)[] = [],
  map = new WeakMap(),
): boolean {
  if (Object.is(objA, objB)) return true;

  if (
    typeof objA !== 'object' ||
    objA === null ||
    typeof objB !== 'object' ||
    objB === null
  ) {
    return false;
  }

  if (map.get(objA) === objB) return true;
  map.set(objA, objB);

  const keysA = Reflect.ownKeys(objA);
  const keysB = Reflect.ownKeys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  for (let i = 0; i < keysA.length; i++) {
    if (ignoredKeys.includes(keysA[i])) {
      continue;
    }

    if (
      !Reflect.has(objB, keysA[i]) ||
      !deepEqual(objA[keysA[i]], objB[keysA[i]], ignoredKeys, map)
    ) {
      return false;
    }
  }

  return true;
}
